import { render, staticRenderFns } from "./PriceListsBulkChanges.vue?vue&type=template&id=61627463&scoped=true"
import script from "./PriceListsBulkChanges.vue?vue&type=script&lang=js"
export * from "./PriceListsBulkChanges.vue?vue&type=script&lang=js"
import style0 from "./PriceListsBulkChanges.vue?vue&type=style&index=0&id=61627463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61627463",
  null
  
)

export default component.exports